import ListPageWrapper from "../../../ListPageWrapper";
import {RouterProps} from "../../../RouterProps";
import {useStatePair} from "react-type-extension";
import {SortOrder} from "ts-protocol-extension";
import {searchIndex, SearchIndex} from "../../../../io/HttpClient";
import ListOption from "../../../ListOption";
import ListOrder from "../../../ListOrder";
import {
    AssetSolarUsageValueObject
} from "../../../../data/value-object/asset/AssetSolarUsageValueObject";
import {
    AssetSolarUsageSearchOption
} from "../../../../data/search-option/asset/AssetSolarUsageSearchOption";
import {AssetSolarUsageIO} from "../../../../io/AssetIO";
import {
    AssetSolarUsageDescription
} from "../../../../data/description/asset/AssetSolarUsageDescription";
import {AssetSolarUsageDescriptor} from "../../../../data/descriptor/asset/AssetSolarUsageDescriptor";
import {
    AssetSolarUsageSearchOptionDescription
} from "../../../../data/description/asset/AssetSolarUsageSearchOptionDescription";
import {
    applyAssetSolarUsageSearchOption,
    AssetSolarUsageSearchOptionField
} from "../../../search-option-field/asset/AssetSolarUsageSearchOptionField";

enum Phase {
    List,
    Option,
    Order
}

export default function List(props: RouterProps) {
    const phase = useStatePair<Phase>(Phase.List)
    const items = useStatePair<AssetSolarUsageValueObject[]>([])
    const option = useStatePair<AssetSolarUsageSearchOption>({})
    const index = useStatePair<SearchIndex>(searchIndex())

    return <>
        {phase.value === Phase.List && <>
            <ListPageWrapper
                {...props}
                client={AssetSolarUsageIO}
                items={items}
                option={option.value}
                index={index}
                description={AssetSolarUsageDescription}
                descriptor={AssetSolarUsageDescriptor}
                showPost
                onPostClick={() => document.location = '/assets/solars/usages/post'}
                showFilter
                onFilterClick={() => phase.setter(Phase.Option)}
                showSort
                onSortClick={() => phase.setter(Phase.Order)}
                onItemClick={item => `/assets/solars/usages/${item.id}`}/>
        </>}
        {phase.value === Phase.Option && <>
            <ListOption
                {...props}
                option={option.value}
                description={AssetSolarUsageSearchOptionDescription}
                fields={AssetSolarUsageSearchOptionField}
                onBackClick={() => phase.setter(Phase.List)}
                onApplyClick={(key, value) => {
                    applyAssetSolarUsageSearchOption(key, value, option)
                    index.setter({ ...index.value, pageIndex: 0n })
                    items.setter([])
                }}
                onDismissClick={key => {
                    const next = { ...option.value }
                    next[key] = undefined
                    option.setter(next)
                    items.setter([])
                }} />
        </>}
        {phase.value === Phase.Order && <>
            <ListOrder
                {...props}
                index={index}
                description={AssetSolarUsageDescription}
                onBackClick={() => phase.setter(Phase.List)}
                onOrderUpdated={() => items.setter([])} />
        </>}
    </>
}